import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconCompanySVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="21.785" height="21.785" viewBox="0 0 21.785 21.785" fill="none"
             className={classNames(['svg-icon svg-company', className])}>
            <path fill="none" d="M0,0H21.785V21.785H0Z"/>
            <path fill={color}
                  d="M11.985,14.8H10.169a.91.91,0,0,1-.908-.908H2.917v3.631a1.821,1.821,0,0,0,1.815,1.815h12.7a1.821,1.821,0,0,0,1.815-1.815V13.893H12.893A.91.91,0,0,1,11.985,14.8Zm6.354-8.169H14.708a3.631,3.631,0,0,0-7.262,0H3.815A1.821,1.821,0,0,0,2,8.446v2.723a1.809,1.809,0,0,0,1.815,1.815H9.262v-.908a.91.91,0,0,1,.908-.908h1.815a.91.91,0,0,1,.908.908v.908h5.446a1.821,1.821,0,0,0,1.815-1.815V8.446A1.821,1.821,0,0,0,18.339,6.631Zm-9.077,0a1.815,1.815,0,0,1,3.631,0H9.262Z"
                  transform="translate(-0.185 -0.277)"/>
        </svg>

    );
};

IconCompanySVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconCompanySVG.defaultProps = {
    color: '#ffffff',
    className: '',
};

export default IconCompanySVG;




